import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'numberWrap',
})
export class NumberWrapPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (value === null || value === undefined) {
      return this.sanitizer.bypassSecurityTrustHtml('');
    }

    const escaped = this.escapeHtml(String(value));

    // wrap plain numbers (sequence of digits) in a span
    const replaced = escaped.replace(/(\d+)/g, '<span class="number">$1</span>');

    return this.sanitizer.bypassSecurityTrustHtml(replaced);
  }

  private escapeHtml(str: string): string {
    return str.replace(/&/g, '\&').replace(/</g, '\<').replace(/>/g, '\>').replace(/"/g, '\"').replace(/'/g, "\'");
  }
}
